import { Descope } from '@descope/react-sdk'

import { useReportErrorsCallback } from '@/lib/connect/error-reporting'

import { useToast } from '@/components/lemmala-design-system/toast/use-toast'

import { IMPERSONATE_SUPPORT_ADMIN_TEXT } from './labels'

type ImpersonateSupportAdminProps = {
  onSuccess?: () => void
}

export const ImpersonateSupportAdmin = ({ onSuccess }: ImpersonateSupportAdminProps) => {
  const { toast } = useToast()
  const reportErrors = useReportErrorsCallback()

  return (
    <div className='mx-auto max-w-lg'>
      <Descope
        flowId='support-admin'
        theme='light'
        form={{
          impersonateId: 'support-user@lema.ai',
        }}
        onSuccess={() => {
          toast({
            variant: 'success',
            title: IMPERSONATE_SUPPORT_ADMIN_TEXT.SUCCESS,
          })
          onSuccess?.()
        }}
        onError={() => {
          reportErrors(new Error(IMPERSONATE_SUPPORT_ADMIN_TEXT.FAILURE))
          toast({
            variant: 'destructive',
            title: IMPERSONATE_SUPPORT_ADMIN_TEXT.FAILURE,
          })
        }}
      />
    </div>
  )
}
